import visaLogo from './assets/visa-logo.png';
import villageLogo from './assets/village-capital-logo.png';

import ecodesignLogo from './assets/ecodesign.png';
import impactLogo from './assets/impact-factory.png';
import ministryLogo from './assets/ministry.png';
import logoCosh from './assets/logo-cosh.png';
import flipLogo from './assets/flip-logo.png';
import fashionCounsil from './assets/fashion-counsil.png';
import ebayLogo from './assets/ebay.png';

export const brandsHomePage = [
    {
        img: impactLogo,
        width: '180px',
    },
    {
        img: flipLogo,
        width: '120px',
    },
    {
        img: ecodesignLogo,
        width: '300px'
    },
    {
        img: ministryLogo,
        width: '240px',

    },
    {
        img: logoCosh,
        width: '120px'
    },
    {
        img: villageLogo,
        width: '300px',

    },
    {
        img: fashionCounsil,
        width: '180px',

    },
    {
        img: ebayLogo,
        width: '180px',

    },
    {
        img: visaLogo,
        width: '120px',

    },
]
